import React, { createContext, useContext, useEffect, useState } from "react";
import { currentUser } from "../mock";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem("ibizz_user");
    if (stored) {
      try {
        setUser(JSON.parse(stored));
      } catch (e) {
        localStorage.removeItem("ibizz_user");
      }
    }
    setLoading(false);
  }, []);

  const login = (userLike) => {
    const u =
      typeof userLike === "string"
        ? { ...currentUser, loginId: userLike || currentUser.loginId }
        : { ...currentUser, ...userLike, loginId: userLike.email || userLike.loginId || currentUser.loginId };
    localStorage.setItem("ibizz_user", JSON.stringify(u));
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem("ibizz_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
